/**
 * All required props
 */
export const LiveProps = {
  showTeamIcon: {
    type: Boolean,
    default: false,
    label: 'show team icon',
  },
  isOverviewProp: {
    type: Boolean,
    default: false,
    label: 'Is Overview',
  },
  titleLive: {
    type: String,
    default: 'Mobile.LiveNow',
    label: 'Live Title'
  },
  showStatistics: {
    type: Boolean,
    default: false,
    label: 'Show statistics option',
  },
  showFavorite: {
    type: Boolean,
    default: true,
    label: 'Show favorites option',
  },
  showIconInTitle: {
    type: Boolean,
    default: false,
    label: 'Show icon in title',
  },
  showAll: {
    type: Boolean,
    default: false,
    label: 'Show all matches',
  },
  maxDisplayedEvents: {
    type: String,
    default: '',
    label: 'number of max matches (leave empty for all)',
  },
  isFavorites: {
    type: Boolean,
    default: false,
    excluded: true,
  },
  showMarketsInMatch: {
    type: Boolean,
    default: false,
    label: 'Show number of markets',
  },
  sport: {
    type: String,
    default: '',
    excluded: true,
  },
  category: {
    type: String,
    default: '',
    excluded: true,
  },
  categoryId: {
    type: Number,
    default: 0,
    excluded: true,
  },
};
